import { formatClassname } from "datastake-daf/src/helpers/ClassesHelper";
import Style from "./style";
import { useTranslation } from "react-i18next";

const defaultTabs = [
  {
    key: 'locations',
    label: 'Locations',
  },
  {
    key: 'entities',
    label: 'DataStore::entities',
  },
  {
    disabled: true,
    key: 'aiQuery',
    label: 'AI Query',
  },
]

export default function Tabs({
  activeTab,
  tabs = defaultTabs,
  setActiveTab = () => { },
}) {
  const { t } = useTranslation();

  return (
    <Style>
      {tabs.map((tab) => (
        <div
          key={tab.key}
          onClick={() => {
            if (!tab.disabled) {
              setActiveTab(tab.key);
            }
          }}
          className={formatClassname(['tab', activeTab === tab.key && 'active', tab.disabled && 'disabled'])}
        >
          <label>{t(tab.label)}</label>
        </div>
      ))}
    </Style>
  );
}
